<template>
  <div class="columns">
    <div class="column"></div>
    <div class="column is-four-fifths">
      <article class="message box p-0 is-primary my-6 has-shadow">
        <p class="message-header">{{ t('login') }}</p>
        <div class="block p-4">
          <form class="message is-primary">
            <div class="block">{{ t('message') }}</div>
            <!-- email -->
            <div class="field">
              <label class="label">{{ t('email') }} </label>
              <div class="control">
                <input
                  class="input is-normal"
                  type="email"
                  placeholder="email"
                  v-model="email"
                />
              </div>
            </div>
            <!-- password -->
            <div class="field">
              <label class="label">{{ t('password') }} </label>
              <div class="control">
                <input
                  class="input"
                  type="password"
                  placeholder="password"
                  v-model="password"
                />
              </div>
            </div>
            <!-- error message -->
            <article v-if="error" class="message is-danger">
              <div class="message-body">
                {{ error }}
              </div>
            </article>
            <!-- Submit  -->
            <div class="field is-grouped is-grouped-centered">
              <p class="control">
                <a class="button is-primary" @click="handleSubmit">
                  {{ t('submit') }}
                </a>
              </p>
            </div>
          </form>
        </div>
      </article>
    </div>
    <div class="column"></div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useUserStore } from '@/stores/UserStore';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import Translations from '@/translations/login.json';

export default {
  setup() {
    // to visualize any error during from processing
    const error = ref(null);
    // Prepare translations
    const { t } = useI18n({
      messages: Translations
    });
    // data field
    const email = ref('');
    const password = ref('');
    // user store
    const user = useUserStore();
    // activate router
    const router = useRouter();

    const handleSubmit = () => {
      // call store to manage login
      const data = {
        email: email.value,
        password: password.value
      };
      user
        .login(data)
        .then(() => {
          error.value = '';
          router.push({ name: 'Home' });
        })
        .catch((err) => {
          console.log('Error: ' + err.code + ' / ' + error.message);
          switch (err.code) {
            case 'auth/invalid-email':
              error.value = 'Invalid email';
              break;
            case 'auth/user-not-found':
              error.value = 'No account with that email was found';
              break;
            case 'auth/wrong-password':
              error.value = 'Incorrect password';
              break;
            default:
              error.value = 'Email or password was incorrect';
              break;
          }
        });
    };

    return {
      handleSubmit,
      email,
      password,
      error,
      t
    };
  }
};
</script>

<style>
</style>